import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TutorialButton from "./tutorialButton";
import CreditStatusButton from "./creditStatusButton";
import NotificationButton from "./notificationButton";
import HistoryDropdown from "../results_reports/HistoryDropdown";
import UserButton from "./userButton";

const MenuHidden = ({
  handleMobileMenuOpen,
  handleMobileMenuClose,
  mobileMenuAnchorEl,
  handleCreditClick,
  handleNotificationClick,
  handleHistoryClick,
  handleUserMenuOpen,
  handleUserMenuClose,
  credits,
  notifications,
  history,
  handleHistorySelect,
  setShowTutorial,
  handleCreditClose,
  creditAnchorEl,
  notificationAnchorEl,
  handleNotificationClose,
  handleNotificationSelect,
  handleProfileClick,
  handleLogout,
  userMenuAnchor,
  historyAnchorEl,
  handleHistoryClose,
}) => {
  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleMobileMenuOpen}
        aria-label="show more"
        aria-controls="mobile-menu"
        aria-haspopup="true"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="mobile-menu"
        anchorEl={mobileMenuAnchorEl}
        keepMounted
        open={Boolean(mobileMenuAnchorEl)}
        onClose={handleMobileMenuClose}
      >
        <MenuItem>
          <TutorialButton setShowTutorial={setShowTutorial} />
        </MenuItem>
        <MenuItem>
          <CreditStatusButton
            handleCreditClick={handleCreditClick}
            credits={credits}
            creditAnchorEl={creditAnchorEl}
            handleCreditClose={handleCreditClose}
          />
        </MenuItem>
        <MenuItem>
          <NotificationButton
            handleNotificationClick={handleNotificationClick}
            notifications={notifications}
            notificationAnchorEl={notificationAnchorEl}
            handleNotificationClose={handleNotificationClose}
            handleNotificationSelect={handleNotificationSelect}
          />
        </MenuItem>
        <MenuItem>
          <HistoryDropdown
            handleHistoryClick={handleHistoryClick}
            historyAnchorEl={historyAnchorEl}
            handleHistoryClose={handleHistoryClose}
            history={history}
            handleHistorySelect={handleHistorySelect}
          />
        </MenuItem>
        <MenuItem>
          <UserButton
            handleUserMenuOpen={handleUserMenuOpen}
            handleUserMenuClose={handleUserMenuClose}
            userMenuAnchor={userMenuAnchor}
            handleProfileClick={handleProfileClick}
            handleLogout={handleLogout}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuHidden;
